import { render, staticRenderFns } from "./PFCustomerWork.vue?vue&type=template&id=3d70d59b"
import script from "./PFCustomerWork.vue?vue&type=script&lang=js"
export * from "./PFCustomerWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports